module.exports = __webpack_public_path__ + "static/renderspecs-27908b27180c5131b051649520c075f2.png";